import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function SupportHelpFrame() {
  const frameRef = useRef(null);
  const location = useLocation();
  const lastPushedUrlRef = useRef(null);

  const supportPath = location.pathname.replace(/^\/help/, '') || '/';
  const src = `https://semrush-support.crazyegg.com${supportPath}${location.search}${location.hash}`;

  useEffect(() => {
    const frame = frameRef.current;

    if (!frame) {
      return;
    }

    const handleLoad = () => {
      try {
        frameRef.current.contentWindow.location.href;
      } catch {
        console.warn('Unable to access iframe content due to cross-origin restrictions.');
      }
    };

    frame.addEventListener('load', handleLoad);

    return () => {
      frame.removeEventListener('load', handleLoad);
    };
  }, []);

  useEffect(() => {
    const url = `${location.pathname}${location.search}${location.hash}`;

    if (lastPushedUrlRef.current === url) {
      return;
    }

    lastPushedUrlRef.current = url;
    window.SM?.client?.('pushUrl', url);
  }, [location.pathname, location.search, location.hash]);

  return (
    <iframe
      ref={frameRef}
      title="Knowledge Base"
      src={src}
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
}
